exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.fake-input[data-v-26a01bbc] {\n  position: absolute;\n  top: 14px;\n  left: 39px;\n}\n", ""]);

